import { useSelector, shallowEqual } from 'react-redux';

interface LocationState {
  location: {
    payload: {
      provider: string | undefined;
    };
    query: {
      code: string | undefined;
    };
  };
}

export function useReduxStateForPortfolioLinkingSuccess() {
  const { provider } = useSelector(
    (state: LocationState) => state.location.payload,
    shallowEqual
  );

  const code = useSelector(
    (state: LocationState) => state.location.query?.code
  );

  return { provider, code };
}
